<template>
  <div class="container">
    <div class="topDiv">
        <div class="topLeft_div">
            <img class="topLeft_image" :src="common.userInfo.photoPath?common.userInfo.photoPath:require(`../../../assets/images/img_default_face_${common.theme}.jpg`)" />
            <div class="topLeft_div1">
                <span class="topLeft_span1">{{common.userTenantInfo.userName}}</span>
                <span class="topLeft_span2">{{common.userTenantInfo.department}}</span>
            </div>
        </div>
         <div class="topRight_div">
              <img class="topRight_icon" src="../../../assets/images/icon_arrows_black_left.png" @click="changeDay(0)" />
              <span class="topRight_span">{{newDatestr}}</span>
              <img class="topRight_icon" src="../../../assets/images/icon_arrows_black_right.png" @click="changeDay(1)" />
        </div>
    </div>
     <div class="calendar_mian_bg">
        <div class="calendar_top">
            <span class="calendar_top_span" v-for="(item,index) in showStrList" :key="index" >{{item}}</span>
        </div>

        <div class="calendar_mian" v-if="showList.length>0">
            <div class="calendar_mian_itemdiv" v-for="(itemList,index) in showList" :key="index">
                <div class="calendar_mian_daydiv" v-for="(item,i) in itemList" :key="i" @click="selectDay(item,index,i)">
                    <img v-if="item.day !=-1 && item.isMark==1 && item.isLast==0 && item.select==1" class="calendar_isMark_selsct" src="../../../assets/images/calendar_normal_l.png" />
                    <img v-if="item.day !=-1 && item.isMark==1 && item.isLast==0 && item.select==0" class="calendar_isMark" src="../../../assets/images/calendar_normal_s.png" />
                    <img v-if="item.day !=-1 && item.isMark==1 && item.isLast==1 && item.select==1" class="calendar_isLast_selsct" src="../../../assets/images/calendar_late_l.png" />
                    <img v-if="item.day !=-1 && item.isMark==1 && item.isLast==1 && item.select==0" class="calendar_isLast"  src="../../../assets/images/calendar_late_s.png" />
                    <div v-if="item.select==1" class="calendar_select"></div>
                    <span v-if="item.select==1" class="calendar_mian_daySpan1">{{item.day}}</span>
                    <span v-else-if="item.isThisDay==1" class="calendar_mian_daySpan2">{{item.day}}</span>
                    <span v-else-if="(item.week==6||item.week ==0) && item.isMark==0 && item.day !=-1" class="calendar_mian_daySpan3">{{item.day}}</span>
                    <span v-else-if="item.day !=-1" class="calendar_mian_daySpan">{{item.day}}</span>
                </div>
            </div>

        </div>
    </div>

    <div class="markInfo" v-if="selectItem" >
        <span class="markInfo_span1">{{selectItem.signTime | signTimeDate}}</span>
        <div class="markInfo_div">
            <span class="markInfo_span2" v-if="selectItem.isLast==0">正常</span>
            <span class="markInfo_span3" v-if="selectItem.isLast==1">迟到</span>
            <span class="markInfo_span4">打卡时间 {{selectItem.signTime | signTime}}</span>
        </div>
    </div>
    <div class="nomarkInfo" v-else>
        <span class="nomarkInfo_span">当天没有打卡记录~</span>
    </div>

   <Tabbar :tab="1" ></Tabbar>
 </div>
</template>
<script>
import Tabbar from "@/pages/smartOffice/StruggleReport/StruggleTabbar.vue";
import Scroll from "@/components/scroll";
import util from "@/utils/util";
import {calendarReport} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            newDatestr:'',
            showStrList:["一","二","三","四","五","六",'日'],
            showList:[],
            signinList:[],
            selectDayStr:'',
            selectItem:'',
            dayList:[
                    {day:1,week:7,isMark:0,isLast:0,select:0,isThisDay:0},
                    {day:2,week:1,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:3,week:2,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:4,week:3,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:5,week:4,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:6,week:5,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:7,week:6,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:8,week:7,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:9,week:1,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:10,week:2,isMark:1,isLast:1 ,select:0,isThisDay:0},
                    {day:11,week:3,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:12,week:4,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:13,week:5,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:14,week:6,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:15,week:7,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:16,week:1,isMark:1,isLast:0 ,select:0,isThisDay:0},
                    {day:17,week:2,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:18,week:3,isMark:1,isLast:1,select:0,isThisDay:1},
                    {day:19,week:4,isMark:1,isLast:1,select:0,isThisDay:0},
                    {day:20,week:5,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:21,week:6,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:22,week:7,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:23,week:1,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:24,week:2,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:25,week:3,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:26,week:4,isMark:1,isLast:0,select:0,isThisDay:0},
                    {day:27,week:5,isMark:0,isLast:0,select:0,isThisDay:0},
                    {day:28,week:6,isMark:0,isLast:0,select:0,isThisDay:0},
                    {day:29,week:7,isMark:0,isLast:0,select:0,isThisDay:0},
                    {day:30,week:1,isMark:0,isLast:0,select:0,isThisDay:0},
                    {day:31,week:2,isMark:0,isLast:0,select:0,isThisDay:0},
                ],

        }
    },
    components:{
        Tabbar,
        Scroll
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
     filters: {
       signTimeDate: function (value) {
            if(!value){
                return '';
            }
            return util.formatTime(new Date(value), 255)
       },
       signTime: function (value) {
           if(!value){
                return '';
           }
           return util.formatTime(new Date(value),22)
       },
    },
    created(){
        this.newDate = new Date();
        this.newDatestr = util.formatTime(new Date(),44)
        this.selectDayStr = util.formatTime(new Date(),4)
        this.initMonthList();
        this.calendarReport();

    },
     methods:{

         initMonthList(){
            var list =[];
            var m = this.newDate.getMonth()+1;
            var mStr ='';
            if(m<10){
                mStr ='0'+m;
            }else{
                mStr=m;
            }
            var year = this.newDate.getFullYear();
            var count =31;
            if(m==4||m==6 ||m==9||m==11){
                count =30;
            }else if(m==2){
                if(year%4==0){
                    count=29;
                }else{
                    count =28;
                }
            }else{
                count =30;
            }
            var tdate =new Date();
            //var sdate =new Date(this.selectDay);
            for(var i=1;i<=count;i++){
                var iStr ='';
                if(i<10){
                    iStr ='0'+i;
                }else{
                    iStr=i;
                }
                var dayString = year+'/'+mStr+'/'+iStr;
                var dayString1 = year+'-'+mStr+'-'+iStr;
                var idate =new Date(dayString);
                var  isThisDay =0;

                if(year == tdate.getFullYear() && m==tdate.getMonth()+1 && i==tdate.getDate()){
                    isThisDay =1;
                    console.log(" in isThisDay")
                }
                var select =0;
                if(this.selectDayStr){
                    if(this.selectDayStr == dayString1){
                        select =1;
                        console.log(" in select")
                    }
                }
                var item ={day:i,week:idate.getDay(),dayString:dayString1, isMark:0,isLast:0,select:select,isThisDay:isThisDay}
                list.push(item);
            }
            this.dayList =  list;
           // console.log(JSON.stringify(this.dayList) );
            this.reSetShowList();

         },
         reSetShowList(){
              this.showList =[];
              var addlist =[];

            for(var i =0;i< this.dayList.length;i++){
                var item =this.dayList[i];
                addlist.push(item);

                if(item.week==0){
                    if(this.showList.length==0){
                        var num = 7-addlist.length;
                        var newList =[];
                        for(var j=0;j<num;j++){
                            newList.push({day:-1,week:j,isMark:0,isLast:0});
                        }
                        newList = newList.concat(addlist)
                        addlist=newList;
                    }
                    this.showList.push(addlist);
                    addlist =[];
                }
            }
            if(addlist.length>0){
                this.showList.push(addlist);
            }
           // console.log(JSON.stringify(this.showList));

         },
         changeDay(flag){
            console.log("in changeDay" +flag);
            if(flag==1){
                var a=  new Date();
                if(a.getFullYear() == this.newDate.getFullYear() &&  this.newDate.getMonth()>=a.getMonth()){
                    return;
                }
                this.newDate.setMonth(this.newDate.getMonth()+1);
                this.newDatestr = util.formatTime(this.newDate,44)

            }else{
                if( this.newDate.getFullYear()==2020 && this.newDate.getMonth()==0){
                    return;
                }
                this.newDate.setMonth(this.newDate.getMonth()-1);
                this.newDatestr = util.formatTime(this.newDate,44)
            }
            this.selectItem='';
            this.initMonthList();
            this.calendarReport();

        },
         selectDay(item,index,num){
             if(item.day ==-1){
                 return;
             }
             this.selectItem='';
             for(var i=0;i<this.showList.length;i++){
                 var ilist = this.showList[i];
                 for(var j=0;j<ilist.length;j++){
                     var jitem =ilist[j];
                     if(i ==index && j==num){
                         //jitem.select==1
                         this.$set(jitem,'select',1)  ;
                         this.selectDayStr =item.dayString;
                         for(var n=0;n<this.signinList.length;n++){
                             var nitem = this.signinList[n];
                             if(nitem.signDate==this.selectDayStr){
                                 this.selectItem = nitem;
                             }
                         }
                     }else{
                         //jitem.select==0
                         this.$set(jitem,'select',0)  ;
                     }
                 }
             }

         },
        calendarReport(){
             let params = {
               // companyId:'2',
                month:this.newDatestr,
                companyId:this.common.userTenantInfo.companyId,
            }
            console.log('params == ' +JSON.stringify(params))
            calendarReport(params).then(res => {
                if (res.res.code === 10000 && res.body) {

                   this.signinList=res.body.signinList;
                   for(var i=0;i<this.signinList.length;i++){
                       var item = this.signinList[i];
                       var idate = new Date(item.signDate);
                       var isdate = new Date(item.signTime);
                       var ltime= isdate -idate;
                       console.log(ltime);
                       if(this.selectDayStr){
                            if(this.selectDayStr == item.signDate){
                                this.selectItem =item;
                                console.log(" in select")
                            }
                        }
                       var isLast =0;
                       if(item.status==3){
                           isLast=1;
                       }
                       item.isLast=isLast
                       for(var j=0;j<this.dayList.length;j++){
                           var jitem = this.dayList[j];
                           if(item.signDate == jitem.dayString){
                               this.$set(jitem,'isMark',1)  ;
                               this.$set(jitem,'isLast',isLast)  ;
                           }

                       }

                   }
                   this.reSetShowList();

                }
            })
         }

     },
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
   // height:100vh;
    background:#EEEEEE;
}
.topDiv{
    width:100%;
    height:120px;
    background:rgba(255,255,255,1);
    box-shadow:0px 8px 16px 0px rgba(0,0,0,0.04);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}
.topLeft_div{
    flex-direction: row;
    height:120px;
    align-items: center;
    display: flex;
    margin-left: 28px;
}
.topLeft_image{
    width:80px;
    height:80px;
    border-radius:40px ;
  //  border:1px solid rgba(182,196,248,1);
}
.topLeft_div1{
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    height:80px;
}
.topLeft_span1{
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.topLeft_span2{
    margin-top: 2px;
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;
}


.topRight_div{
    display: flex;
    margin-right: 28px;
    align-items: center;
    flex-direction: row;
}
.topRight_icon{
    width: 32px;
    height: 32px;
}
.topRight_span{
    height:48px;
    margin-bottom: 2px;
    font-size:32px;
    margin-left: 12px;
    margin-right: 12px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:48px;
}

.calendar_top{
    margin-left: 20px;
    width: 710px;
    flex-direction: row;
    display: flex;
}
.calendar_top_span{
    width: 101px;
    height: 60px;
    text-align: center;
    font-size:22px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:60px;
}
.calendar_mian_bg{
    background-color: #FAFAFA;
    width: 100%;
    flex-direction: column;
}
.calendar_mian{
    margin-top: 20px;
    margin-left: 20px;
    width: 710px;
    flex-direction: column;

   padding-bottom: 20px;
}
.calendar_mian_itemdiv{
    width: 710px;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
}
.calendar_mian_daydiv{
    position: relative;
    width: 60px;
    margin-left: 20px;
    margin-right: 21px;
    height: 60px;
    display: flex;
}
.calendar_isMark{
    position:absolute;
    z-index: 1;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
   // border-radius: 100%;
    // border:4px solid;
    // border-image:linear-gradient(138deg, rgba(22,188,132,0.12), rgba(22,188,132,0.5)) 4 4;
}
.calendar_isMark_selsct{
    position:absolute;
    z-index: 1;
    width: 72px;
    height: 72px;
    left: -6px;
    top: -6px;
}

.calendar_isLast{
    position:absolute;
    z-index: 1;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
}
.calendar_isLast_selsct{
    position:absolute;
    z-index: 1;
    width: 72px;
    height: 72px;
    left: -6px;
    top: -6px;
}
.calendar_select{
    position:absolute;
    left: 2px;
    top: 2px;
    border-radius: 100%;
    z-index: 1;
    width:56px;
    height:56px;
    background:rgba(23,64,218,1);

}
.calendar_mian_daySpan{
    position:absolute;
    z-index: 11;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
    text-align: center;
    font-size:32px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:60px;

}
.calendar_mian_daySpan1{
    position:absolute;
    z-index: 11;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
    text-align: center;
    font-size:32px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:60px;

}
.calendar_mian_daySpan2{
    position:absolute;
    z-index: 11;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
    text-align: center;
    font-size:32px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:60px;

}
.calendar_mian_daySpan3{
    position:absolute;
    z-index: 11;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
    text-align: center;
    font-size:32px;
    font-weight:400;
    color:rgba(102,102,102,0.4);
    line-height:60px;

}
.markInfo{
    margin-top: 20px;
    margin-left: 20px;
    flex-direction: column;
    display: flex;
    width:710px;
    height:184px;
    background:rgba(255,255,255,1);
    border-radius:16px;
}
.markInfo_span1{
    height:44px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    margin-top: 28px;
    margin-left: 28px;
}
.markInfo_div{
    flex-direction: row;
    display: flex;
    margin-top: 28px;
    margin-left: 28px;
}
.markInfo_span2{
    width:68px;
    height:40px;
    text-align: center;
    background:rgba(22,188,132,1);
    border-radius:20px;
    font-size:22px;
    font-weight:500;
    color:rgba(250,250,250,1);
    line-height:40px;
}
.markInfo_span3{
    width:68px;
    height:40px;
    text-align: center;
    background:#FD9838;
    border-radius:20px;
    font-size:22px;
    font-weight:500;
    color:rgba(250,250,250,1);
    line-height:40px;
}
.markInfo_span4{
    margin-left: 20px;
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.nomarkInfo{
    flex-direction: row;
    display: flex;
    margin-top: 80px;
    margin-left: 20px;
    width: 710px;
}
.nomarkInfo_span{
    width: 710px;
    text-align: center;
    font-size:32px;
    font-weight:400;
    color:rgba(201,201,201,1);
    line-height:44px;
}


</style>